import PropTypes from 'prop-types';

// Components
import { DetailedIconPiggybank, Flex, Spacer } from '@zillow/constellation';
import { Button, TextButton } from '@zillow/constellation-10';

import InlineStyledText from '../InlineStyledText';

import {
  StyledSecondaryButtonHideShowContainer,
  StyledSecondaryTextButtonHideShowContainer,
} from '../../../../StyledComponents/StyledComponents';

import { StyledEmptyIconContainer, StyledEmptyStateContainer } from '../../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText, StyledEmptySimpleCard } from '../../../../styles';

const EmptyPaymentsCard = ({ title, description, ctaLink, ctaPrimaryButton, disclaimer }) => {
  const getDisclaimerText = (styledTextList) =>
    styledTextList.map((styledText) => ({
      styling: 'legal',
      ...styledText,
    }));

  const getSecondaryCTAShowHide = () => {
    return (
      <>
        <StyledSecondaryButtonHideShowContainer>
          <Button
            asChild
            data-testid="empty-payments-card-default-button"
            href={ctaLink.url}
            tone="brand"
            emphasis="outlined"
            css={{ marginLeft: '200' }}
          >
            <a href={ctaLink.url}>{ctaLink.text}</a>
          </Button>
        </StyledSecondaryButtonHideShowContainer>

        <StyledSecondaryTextButtonHideShowContainer>
          <TextButton css={{ paddingTop: '200' }} asChild data-testid="empty-leases-card-default-anchor">
            <a href={ctaLink.url}>{ctaLink.text}</a>
          </TextButton>
        </StyledSecondaryTextButtonHideShowContainer>
      </>
    );
  };

  return (
    <StyledEmptySimpleCard
      isDisabled={true}
      css={{ padding: '{spacing.1000} {spacing.600}' }}
      data-testid="empty-payments-card"
    >
      <StyledEmptyStateContainer>
        <StyledEmptyIconContainer>
          <DetailedIconPiggybank />
        </StyledEmptyIconContainer>

        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild css={{ textAlign: 'center' }}>
          <p>{description}</p>
        </EmptyStateBodyText>

        <Flex
          display="flex"
          flexDirection={{ default: 'column', lg: 'row' }}
          alignItems="center"
          justifyContent="center"
        >
          <Button asChild tone="brand" emphasis="filled">
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>

          {ctaLink.text && ctaLink.url && getSecondaryCTAShowHide()}
        </Flex>

        {disclaimer && (
          <>
            <Spacer marginBottom="md" />
            <InlineStyledText styledTextList={getDisclaimerText(disclaimer)} />
          </>
        )}
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};

EmptyPaymentsCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaLink: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  ctaPrimaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  disclaimer: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default EmptyPaymentsCard;
